import _get from 'lodash/get';

import {
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_RESET,
  PATCH_TRANSACTION,
  PATCH_TRANSACTION_RESET,
  TOGGLE_TRANSACTION,
  RESET_SELECTED_TRANSACTIONS,
  SUBMIT_OTP,
  RESEND_OTP,
  POST_BATCH,
  TOGGLE_TRANSACTIONS,
} from './transactions.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const initialTransactionsData = {
  transactions: [],
  count: null,
};

const defaultState = {
  transactionsData: { ...initialTransactionsData },
  selectedTransactions: {},
  selectedTransactionsArray: [],
  selectedTab: '',
  isFetching: false,
  patchRefreshPending: false,
  batchId: '',
  totalAmount: 0,
  otpSubmitted: false,
  resendOtp: false,
};

export default function (state = defaultState, action) {
  switch (action?.type) {
    case FETCH_TRANSACTIONS[REQUEST]: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case FETCH_TRANSACTIONS[SUCCESS]: {
      const listData = action.response?.data || { count: 0, size: 0, page: 0, transactions: [] };
      const count = listData?.count || 0;
      let newListObj = {};
      if (!!count) {
        let type = (action.params.status && action.params.status.toUpperCase()) || 'COMMON';
        newListObj = { ...state.transactionsData };
        newListObj.transactions = newListObj?.transactions?.length
          ? newListObj.transactions.concat(listData.transactions)
          : listData.transactions;
        newListObj.count = count;
        state.transactionsData = newListObj;
        if (type === 'COMMON') {
          let status = _get(newListObj, 'transaction[0].status', '');
          let tab = '';
          if (['PENDING', 'APPROVED', 'DONE', 'FAIL'].includes(status.toUpperCase())) {
            tab = status.toUpperCase();
          }
          state.TransactionsData = newListObj;
          state.selectedTab = tab;
        }
        return { ...state, transactionsData: newListObj, isFetching: false };
      }
    }

    case FETCH_TRANSACTIONS[FAILURE]: {
      return {
        ...state,
        transactionsData: {
          transactions: [],
          count: null,
        },
        isFetching: false,
      };
    }
    case FETCH_TRANSACTIONS_RESET: {
      return {
        ...state,
        transactionsData: {
          transactions: [],
          count: null,
        },
        isFetching: false,
      };
    }
    case PATCH_TRANSACTION[SUCCESS]: {
      return { ...state, patchRefreshPending: true };
    }
    case PATCH_TRANSACTION[FAILURE]: {
      return { ...state, patchRefreshPending: true };
    }
    case PATCH_TRANSACTION_RESET: {
      return { ...state, patchRefreshPending: false };
    }
    case POST_BATCH[REQUEST]: {
      return { ...state, batchId: '' };
    }
    case POST_BATCH[SUCCESS]: {
      const batchId = action.response?.data?.batchId || '';
      return { ...state, batchId: batchId };
    }
    case POST_BATCH[FAILURE]: {
      return { ...state, batchId: '' };
    }
    case SUBMIT_OTP[REQUEST]: {
      return { ...state, otpSubmitted: false };
    }
    case SUBMIT_OTP[SUCCESS]: {
      return { ...state, otpSubmitted: true, selectedTransactions: {}, selectedTransactionsArray: [] };
    }
    case SUBMIT_OTP[FAILURE]: {
      const errorStatus = action?.response?.status;
      if (errorStatus === 410) {
        return { ...state, otpSubmitted: true, selectedTransactions: {}, selectedTransactionsArray: [] };
      }
      return { ...state, otpSubmitted: false };
    }
    case RESEND_OTP[REQUEST]: {
      return { ...state, otpResent: false };
    }
    case RESEND_OTP[SUCCESS]: {
      return { ...state, otpResent: 'success' };
    }
    case RESEND_OTP[FAILURE]: {
      return { ...state, otpResent: 'error' };
    }
    case TOGGLE_TRANSACTION: {
      const transaction = action.params.transaction;
      const id = transaction?.id || '';
      let amount = 0;
      let updatedSelectedTransactions = { ...state.selectedTransactions };
      if (!!updatedSelectedTransactions[id]) {
        delete updatedSelectedTransactions[id];
      } else {
        updatedSelectedTransactions[id] = transaction;
      }
      const updatedSelectedTransactionsArray = Object.keys(updatedSelectedTransactions).map(
        (key) => updatedSelectedTransactions[key],
      );
      updatedSelectedTransactionsArray.forEach((each) => {
        amount = amount + each['amt'];
      });
      return {
        ...state,
        totalAmount: amount,
        selectedTransactions: updatedSelectedTransactions,
        selectedTransactionsArray: updatedSelectedTransactionsArray,
      };
    }
    case TOGGLE_TRANSACTIONS: {
      const { transaction, isChecked } = action.params;
      const id = transaction?.id || '';
      let amount = 0;
      let updatedSelectedTransactions = { ...state.selectedTransactions };
      if (isChecked) {
        updatedSelectedTransactions[id] = transaction;
      } else {
        if (!!updatedSelectedTransactions[id]) {
          delete updatedSelectedTransactions[id];
        }
      }
      const updatedSelectedTransactionsArray = Object.keys(updatedSelectedTransactions).map(
        (key) => updatedSelectedTransactions[key],
      );
      updatedSelectedTransactionsArray.forEach((each) => {
        amount = amount + each['amt'];
      });
      return {
        ...state,
        totalAmount: amount,
        selectedTransactions: updatedSelectedTransactions,
        selectedTransactionsArray: updatedSelectedTransactionsArray,
      };
    }

    case RESET_SELECTED_TRANSACTIONS: {
      return { ...state, selectedTransactions: {}, selectedTransactionsArray: [] };
    }

    default:
      return { ...state };
  }
}
